import {
  EClickableSize,
  EClickableTarget,
  EClickableTypes,
} from '@/components/atoms/at-clickable/at-clickable.types';
import { IAtLinkGlobalFieldProps } from '@/lib/contentstack-sdk/types';
import { EIcons } from '@/components/atoms/at-icon/icons';
import { ILinkList, IOrNavbarProps } from './or-navbar.types';

const mockLinkList: ILinkList[] = [
  {
    nav_item: {
      title: 'Customizable Home Plans',

      sub_links: [
        {
          links: {
            title: '',
            link: [
              {
                nav_link_content: {
                  content: {
                    title: 'Browse Home Plans',
                    href: '/',
                  },
                },
              },
              {
                nav_link_content: {
                  content: {
                    title: 'Gallery',
                    href: '/',
                  },
                },
              },
              {
                nav_link_content: {
                  content: {
                    title: 'Included Features',
                    href: '/',
                  },
                },
              },
              {
                nav_link_content: {
                  content: {
                    title: 'Lot Vision',
                    href: '/',
                  },
                },
              },
              {
                nav_link_content: {
                  content: {
                    title: 'Accessible Home Design',
                    href: '/',
                  },
                },
              },
              {
                nav_link_content: {
                  content: {
                    title: 'Multi-Generational Living',
                    href: '/',
                  },
                },
              },
            ],
          },
        },
      ],
      link_card: [
        {
          background_image: {
            entry_title: 'View on your lot background',
            alt: 'lorem ipsum',
            mobile_image_url:
              'https://images.contentstack.io/v3/assets/blte8e7d2bd4f946026/blta253d0efac7192d8/67b8818684d14b4c1b79a628/cta-card-test.png',
            tablet_image_url: '',
            desktop_image_url: '',
          },
          content_title: 'View on your lot',
          size: EClickableSize.LG,
          description: 'Envision what this plan looks like on your land',
          icon: {
            icon: EIcons.CIRCLE,
          },
          link: {
            label: 'Learn More',
            url: {
              title: 'Learn More',
              href: '/',
            },
            aria_label: 'Learn more about lot viewer',
            type: EClickableTypes.CTA,
            variant: 'PRIMARY',
            target: EClickableTarget.BLANK,
            outline: true,
            size: 'LG',
            icon: [],
          },
          show_cta: true,
          theme: {
            theme: 'DARK',
          },
        },
      ],
    },
  },
  {
    nav_item: {
      title: 'Why Schumacher',

      sub_links: [
        {
          links: {
            title: '',
            link: [
              {
                nav_link_content: {
                  content: {
                    title: 'The Schumacher Way',
                    href: '/',
                  },
                },
              },
              {
                nav_link_content: {
                  content: {
                    title: 'Our Process',
                    href: '/',
                  },
                },
              },
              {
                nav_link_content: {
                  content: {
                    title: 'FAQs',
                    href: '/',
                  },
                },
              },
              {
                nav_link_content: {
                  content: {
                    title: 'Customer Stories',
                    href: '/',
                  },
                },
              },
            ],
          },
        },
        {
          links: {
            title: 'More Perks',
            link: [
              {
                nav_link_content: {
                  content: {
                    title: 'Download the guidebook',
                    href: '/',
                  },
                },
              },
            ],
          },
        },
      ],
      link_card: [
        {
          background_image: {
            entry_title: 'View on your lot background',
            alt: 'lorem ipsum',
            mobile_image_url:
              'https://images.contentstack.io/v3/assets/blte8e7d2bd4f946026/blta253d0efac7192d8/67b8818684d14b4c1b79a628/cta-card-test.png',
            tablet_image_url: '',
            desktop_image_url: '',
          },
          content_title: 'View on your lot',
          size: EClickableSize.LG,
          description: 'Envision what this plan looks like on your land',
          icon: {
            icon: EIcons.INSTAGRAM,
          },
          link: {
            label: 'Learn More',
            url: {
              title: 'Learn More',
              href: '/',
            },
            aria_label: 'Learn more about lot viewer',
            type: EClickableTypes.CTA,
            variant: 'PRIMARY',
            target: EClickableTarget.BLANK,
            outline: true,
            size: 'LG',
            icon: [],
          },
          theme: {
            theme: 'DARK',
          },
        },
      ],
    },
  },
];

const topNavActionMock: IAtLinkGlobalFieldProps[] = [
  {
    aria_label: '',
    icon: [],
    label: 'Schedule A Meeting',
    outline: false,
    size: 'SM',
    target: EClickableTarget.BLANK,
    type: EClickableTypes.CTA,
    url: {
      title: 'Schedule A Meeting',
      href: ':openLoginModal',
    },
    variant: 'PRIMARY',
  },
  {
    aria_label: 'Log into my Schumacher',
    icon: [],
    label: 'Log in',
    outline: false,
    size: 'SM',
    target: EClickableTarget.BLANK,
    type: EClickableTypes.CTA,
    url: {
      title: 'Log In',
      href: ':openLoginModal',
    },
    variant: 'DIMINUTIVE',
  },
];

export const orNavbarMockData: IOrNavbarProps = {
  topNavActions: topNavActionMock,
  links: mockLinkList,
  chat: {
    content: 'Check out our chat!',
  },
  phoneNumber: '888-409-0577',
};
